import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface GetOverviewBranchSubscriptionRequest extends HttpRequestData {
    readonly startTime: string;
    readonly endTime: string;
    readonly isNewBranchSubscription: boolean | null;
}

export interface GetOverviewBranchSubscriptionResponseItem {
    currentBranchSubscriptionCount: number;
    pastBranchSubscriptionCount: number;
}

export const getOverviewBranchSubscription = httpUtil.createHttpRequestMeta<
    GetOverviewBranchSubscriptionRequest,
    GetOverviewBranchSubscriptionResponseItem
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/branch-subscriptions/overview',
    method: 'GET',
    authentication: 'bearer',
});